import { useTenantStore } from "@/store/tenant";
import { defineAsyncComponent, markRaw, computed, ComponentPublicInstance } from 'vue';


export default () => {
  interface ComponentList {
    [key: string]: () => Promise<any>;
  }
  const tenantStore = useTenantStore();

  const {
    themeConfig
  } = toRefs(tenantStore);
  const themeHomeType = ref('blue-default-GameType');
  // 组件加载器
  const loadComponent = (list: ComponentList) => computed(() => {
    const { theme, home, homeType } = tenantStore.themeConfig ?? {};
    themeHomeType.value = `${theme}-${home ? (home + '-') : ''}${homeType ?? 'GameType'}`;
    const components = list[themeHomeType.value] || list['blue-default-GameType'] || null;
    if (components) {
      const asyncComponent = defineAsyncComponent(components);
      return markRaw(asyncComponent) as unknown as ComponentPublicInstance | null;
    }
    return null;
  });

  // 头部pwa推广
  const pwaViewList: ComponentList = {
    'blue-default-GameType': () => import('@/pwa/HeaderBar/Default.vue'),
    'blue-default-Platform': () => import('@/pwa/HeaderBar/Default.vue'),
    'green-default-v01-GameType': () => import('@/pwa/HeaderBar/Default.vue'),
    'green-default-v01-Platform': () => import('@/pwa/HeaderBar/Default2.vue'),
    'green-default-v02-Platform': () => import('@/pwa/HeaderBar/Default2.vue'),
  };

  const headerBarList: ComponentList = {
    'blue-default-GameType': () => import('@/views/tabbar/tabs/inicio/components/HeaderBar/default/HeaderBar1/index.vue'),
    'blue-default-v01-GameType': () => import('@/views/tabbar/tabs/inicio/components/HeaderBar/default/HeaderBar2/index.vue'),
  };

  // 活动推广
  const activityList: ComponentList = {
    'blue-default-GameType': () => import('@/views/tabbar/tabs/inicio/components/ActivityBar/default/ActivityBar1/index.vue'),
    'blue-default-Platform': () => import('@/views/tabbar/tabs/inicio/components/ActivityBar/default/ActivityBar2/index.vue'),
    'blue-default-v01-GameType': () => import('@/views/tabbar/tabs/inicio/components/ActivityBar/default/ActivityBar4/index.vue'),
    'green-default-v01-GameType': () => import('@/views/tabbar/tabs/inicio/components/ActivityBar/default/ActivityBar1/index.vue'),
    'green-default-v01-Platform': () => import('@/views/tabbar/tabs/inicio/components/ActivityBar/default/ActivityBar3/index.vue'),
    'green-default-v02-Platform': () => import('@/views/tabbar/tabs/inicio/components/ActivityBar/default/ActivityBar3/index.vue'),
  };

  // 跑马灯
  const marqueeList: ComponentList = {
    'blue-default-GameType': () => import('@/views/tabbar/tabs/inicio/components/MarqueeView/default/MarqueeView1/index.vue'),
    'blue-default-Platform': () => import('@/views/tabbar/tabs/inicio/components/MarqueeView/default/MarqueeView1/index.vue'),
    'blue-default-v01-GameType': () => import('@/views/tabbar/tabs/inicio/components/MarqueeView/default/MarqueeView1/index.vue'),
    'green-default-v01-GameType': () => import('@/views/tabbar/tabs/inicio/components/MarqueeView/default/MarqueeView1/index.vue'),
    'green-default-v01-Platform': () => import('@/views/tabbar/tabs/inicio/components/MarqueeView/default/MarqueeView2/index.vue'),
    'green-default-v02-Platform': () => import('@/views/tabbar/tabs/inicio/components/MarqueeView/default/MarqueeView2/index.vue'),
  };

  // 游戏导航标签
  const segmentList: ComponentList = {
    'blue-default-GameType': () => import('@/views/tabbar/tabs/inicio/components/Segment/default/Segment1/index.vue'),
    'blue-default-Platform': () => import('@/views/tabbar/tabs/inicio/components/Segment/default/Segment2/index.vue'),
    'blue-default-v01-GameType': () => import('@/views/tabbar/tabs/inicio/components/Segment/default/Segment5/index.vue'),
    'green-default-v01-GameType': () => import('@/views/tabbar/tabs/inicio/components/Segment/default/Segment1/index.vue'),
    'green-default-v01-Platform': () => import('@/views/tabbar/tabs/inicio/components/Segment/default/Segment3/index.vue'),
    'green-default-v02-Platform': () => import('@/views/tabbar/tabs/inicio/components/Segment/default/Segment4/index.vue'),
  };

  // 热门游戏组件
  const popularList: ComponentList = {
    'blue-default-GameType': () => import('@/views/tabbar/tabs/inicio/components/PopularView/default/index.vue'),
    'blue-default-Platform': () => import('@/views/tabbar/tabs/inicio/components/PopularView/defaultTwo/index.vue'),
    'green-default-v01-GameType': () => import('@/views/tabbar/tabs/inicio/components/PopularView/default/index.vue'),
    'green-default-v01-Platform': () => import('@/views/tabbar/tabs/inicio/components/PopularView/defaultThree/index.vue'),
  }

  // 体育游戏组件
  const sportList: ComponentList = {
    'blue-default-GameType': () => import('@/views/tabbar/tabs/inicio/components/SportView/default/index.vue'),
    'blue-default-Platform': () => import('@/views/tabbar/tabs/inicio/components/SportView/defaultTwo/index.vue'),
    'green-default-v01-GameType': () => import('@/views/tabbar/tabs/inicio/components/SportView/default/index.vue'),
    'green-default-v01-Platform': () => import('@/views/tabbar/tabs/inicio/components/SportView/defaultThree/index.vue'),
  };
  // 游戏排序组件
  const sortList: ComponentList = {
    'blue-default-GameType': () => import('@/views/tabbar/tabs/inicio/components/SortView/default/index.vue'),
    'blue-default-Platform': () => import('@/views/tabbar/tabs/inicio/components/SortView/defaultTwo/index.vue'),
    'green-default-v01-GameType': () => import('@/views/tabbar/tabs/inicio/components/SortView/default/index.vue'),
    'green-default-v01-Platform': () => import('@/views/tabbar/tabs/inicio/components/SortView/defaultThree/index.vue'),
  }
  // app下载组件
  const appInstallList: ComponentList = {
    'blue-default-GameType': () => import('@/views/tabbar/tabs/inicio/components/AppInstall/default/AppInstall1/index.vue'),
    'blue-default-Platform': () => import('@/views/tabbar/tabs/inicio/components/AppInstall/default/AppInstall2/index.vue'),
    'blue-default-v01-GameType': () => import('@/views/tabbar/tabs/inicio/components/AppInstall/default/AppInstall4/index.vue'),
    'green-default-v01-GameType': () => import('@/views/tabbar/tabs/inicio/components/AppInstall/default/AppInstall1/index.vue'),
    'green-default-v01-Platform': () => import('@/views/tabbar/tabs/inicio/components/AppInstall/default/AppInstall3/index.vue'),
    'green-default-v02-Platform': () => import('@/views/tabbar/tabs/inicio/components/AppInstall/default/AppInstall3/index.vue'),
  }
  // 底部文案组件
  const footerContentList: ComponentList = {
    'blue-default-GameType': () => import('@/views/tabbar/tabs/inicio/components/FooterContent/default/FooterContent1/index.vue'),
    'blue-default-Platform': () => import('@/views/tabbar/tabs/inicio/components/FooterContent/default/FooterContent2/index.vue'),
    'blue-default-v01-GameType': () => import('@/views/tabbar/tabs/inicio/components/FooterContent/default/FooterContent4/index.vue'),
    'green-default-v01-GameType': () => import('@/views/tabbar/tabs/inicio/components/FooterContent/default/FooterContent1/index.vue'),
    'green-default-v01-Platform': () => import('@/views/tabbar/tabs/inicio/components/FooterContent/default/FooterContent3/index.vue'),
    'green-default-v02-Platform': () => import('@/views/tabbar/tabs/inicio/components/FooterContent/default/FooterContent3/index.vue'),
  }
  // 三方合作组件
  const partViewList: ComponentList = {
    'blue-default-GameType': () => import('@/views/tabbar/tabs/inicio/components/PartView/default/PartView1/index.vue'),
    'blue-default-Platform': () => import('@/views/tabbar/tabs/inicio/components/PartView/default/PartView2/index.vue'),
    'blue-default-v01-GameType': () => import('@/views/tabbar/tabs/inicio/components/PartView/default/PartView4/index.vue'),
    'green-default-v01-GameType': () => import('@/views/tabbar/tabs/inicio/components/PartView/default/PartView1/index.vue'),
    'green-default-v01-Platform': () => import('@/views/tabbar/tabs/inicio/components/PartView/default/PartView3/index.vue'),
    'green-default-v02-Platform': () => import('@/views/tabbar/tabs/inicio/components/PartView/default/PartView3/index.vue'),
  }
  // 游戏分类列表组件
  const gameClassList: ComponentList = {
    'blue-default-Platform': () => import('@/views/tabbar/tabs/inicio/components/GameClassification/Class1.vue'),
  }

  // 奖池组件
  const bonusPoolList: ComponentList = {
    'blue-default-v01-GameType': () => import('@/components/BonusPool/BonusPool1.vue'),
    'green-default-v01-Platform': () => import('@/components/BonusPool/BonusPool1.vue'),
    'green-default-v02-Platform': () => import('@/components/BonusPool/BonusPool1.vue'),
  }

  const gameTabList: ComponentList = {
    'green-default-v02-Platform': () => import('@/views/tabbar/tabs/inicio/components/GameWrapper/Tabs/Tabs1.vue'),
  }

  const customerServiceButtonList: ComponentList = {
    'blue-default-GameType': () => import('@/views/tabbar/tabs/inicio/components/CustomerServiceButton/Button1/index.vue'),
    'blue-default-v01-GameType': () => import('@/views/tabbar/tabs/inicio/components/CustomerServiceButton/Button2/index.vue'),
  }

  const toTopButtonList: ComponentList = {
    'blue-default-GameType': () => import('@/views/tabbar/tabs/inicio/components/ToTopButton/Button1/index.vue'),
    'blue-default-Platform': () => import('@/views/tabbar/tabs/inicio/components/ToTopButton/Button2/index.vue'),
    'green-default-v01-Platform': () => import('@/views/tabbar/tabs/inicio/components/ToTopButton/Button2/index.vue'),
    'green-default-v02-Platform': () => import('@/views/tabbar/tabs/inicio/components/ToTopButton/Button2/index.vue'),
  }

  // 使用加载器加载组件
  const segmentComponent = loadComponent(segmentList);
  const activityComponent = loadComponent(activityList);
  const appInstallComponent = loadComponent(appInstallList);
  const footerContentComponent = loadComponent(footerContentList);
  const partViewComponent = loadComponent(partViewList);
  const pwaViewComponent = loadComponent(pwaViewList);
  const marqueeComponent = loadComponent(marqueeList);
  const gameClassComponent = loadComponent(gameClassList);
  const bonusPoolComponent = loadComponent(bonusPoolList);
  const gameTabComponent = loadComponent(gameTabList);
  const headerBarComponent = loadComponent(headerBarList);
  const toTopButtonComponent = loadComponent(toTopButtonList);
  const customerServiceButtonComponent = loadComponent(customerServiceButtonList);

  return {
    themeConfig,
    themeHomeType,
    gameTabComponent,
    marqueeComponent,
    pwaViewComponent,
    segmentComponent,
    partViewComponent,
    activityComponent,
    headerBarComponent,
    gameClassComponent,
    bonusPoolComponent,
    appInstallComponent,
    toTopButtonComponent,
    footerContentComponent,
    customerServiceButtonComponent,
  }
}
